module.exports = __webpack_public_path__ + "img/10.1f0149f7.jpg";